import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import CallerStats from './components/CallerStats';
import CallersList from './components/CallersList';
import TeamRanking from './components/TeamRanking';
import Login from './components/Login';
import UserProfile from './components/UserProfile';
import TeamList from './components/TeamList';
import UserData from './components/UserData';

function ProtectedRoute({ children, requiredRole = null, requiredArea = null }) {

  const authToken = localStorage.getItem('authToken');
  const userRole = localStorage.getItem('userRole');
  const userAreaId = localStorage.getItem('userAreaId');
  const isCaller = localStorage.getItem('isCaller') === 'true';
  const callerZoomName = localStorage.getItem('zoomName');
  const navigate = useNavigate();

  React.useEffect(() => {

    const pathname = window.location.pathname;

    if ( authToken && isCaller && !pathname.startsWith('/caller/') && pathname !== '/ranking' && pathname !== '/profile') {

      navigate(`/caller/${encodeURIComponent(callerZoomName)}`, { replace: true });

    }

  }, [authToken, isCaller, callerZoomName, navigate]);

  if (!authToken) {

    return <Navigate to="/login" replace />;

  }

  if (isCaller && userAreaId === '2') {

    const pathname = window.location.pathname;

    if (pathname.startsWith('/caller/')) {

      const requestedName = decodeURIComponent(pathname.split('/caller/')[1]);

      if (requestedName !== callerZoomName) {

        return <Navigate to={`/caller/${encodeURIComponent(callerZoomName)}`} replace />;

      }

    }

  }

  if (userRole === 'admin') {

    return children;

  }

  if (requiredRole && userRole !== requiredRole) {

    return <Navigate to="/" replace />;

  }

  return children;

}

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="caller/:name" element={
            <ProtectedRoute>
              <CallerStats />
            </ProtectedRoute>
          } />
          <Route path="callers" element={
            <ProtectedRoute requiredRole="moderator">
              <CallersList />
            </ProtectedRoute>
          } />
          <Route path="ranking" element={
            <ProtectedRoute>
              <TeamRanking />
            </ProtectedRoute>
          } />  
          <Route path="profile" element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          } />
          <Route path="team_list" element={
            <ProtectedRoute requiredRole="admin">
              <TeamList />
            </ProtectedRoute>
          } />
          <Route path="user_data/:id" element={
            <ProtectedRoute requiredRole="admin">
              <UserData />
            </ProtectedRoute>
          } />

        </Route>  
      </Routes>
    </Router>
  );

}

export default App;
